import React, {useState} from 'react'
import {Button, message, notification} from 'antd'
import parseToken from "../../../../helpers/parseToken";
import {formatDateFromLocal} from "../../../../helpers/formatDate";
import {reportDetailFeeGGSheet} from "../../../../services/api/apiCustomerHub"
import {exportCallLogCSV, exportFee6s1CSV} from "../../../../services/api/apiReport";

const Export = (props) => {
  const decodeToken = parseToken()
  const {filters} = props
  const [loadingE, setLoadingE] = useState(false)
  const [loadingCallLog, setLoadingCallLog] = useState(false)
  const [loadingFee6s1, setLoadingFee6s1] = useState(false)

  const _downloadBlob = (blobData, fileName) => {
    const href = URL.createObjectURL(blobData)
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
  }

  const _buildExportPayload = () => {
    return {
      fromDate: filters?.fromDate?.toISOString ? filters.fromDate.toISOString() : formatDateFromLocal(filters?.fromDate),
      toDate: filters?.toDate?.toISOString ? filters.toDate.toISOString() : formatDateFromLocal(filters?.toDate),
      tenantId: filters?.tenantId || ''
    }
  }

  const _onExportGoogle = async () => {
    setLoadingE(true)

    try {
      const response = await reportDetailFeeGGSheet(decodeToken.sub, {
        fromDate: formatDateFromLocal(filters.fromDate),
        shortPhone: filters?.shortPhone,
        tenantId: filters?.tenantId,
        toDate: formatDateFromLocal(filters.toDate)
      })

      const {success, error_message} = response

      if (success !== '1') {
        setLoadingE(false)
        return message.error(error_message)
      }

      setLoadingE(false)
      notification.success({
        message: 'Export thành công',
        description: <div>
          Export ra link thành công bạn có thể kiểm tra dữ liệu ở
          <a rel="noreferrer" href={error_message} target="_blank"> link</a>
        </div>,
        duration: 0
      })
    } catch (e) {
      setLoadingE(false)
      message.error(e.message)
    }
  }

  const _onExportCallLog = async () => {
    setLoadingCallLog(true)

    try {
      const response = await exportCallLogCSV(_buildExportPayload(), decodeToken.sub)
      _downloadBlob(response, 'chi-tiet-call-log.csv')
    } catch (e) {
      message.error(e.message)
    } finally {
      setLoadingCallLog(false)
    }
  }

  const _onExportFee6s1 = async () => {
    setLoadingFee6s1(true)

    try {
      const response = await exportFee6s1CSV(_buildExportPayload(), decodeToken.sub)
      _downloadBlob(response, 'chi-tiet-cuoc-6s1.csv')
    } catch (e) {
      message.error(e.message)
    } finally {
      setLoadingFee6s1(false)
    }
  }

  return (
    <>
      <Button key="submit" type="primary" loading={loadingE} onClick={_onExportGoogle}>
        Chi tiết cước
      </Button>
      <Button className="ml-2" type="primary" loading={loadingCallLog} onClick={_onExportCallLog}>
        Chi tiết call log
      </Button>
      <Button className="ml-2" type="primary" loading={loadingFee6s1} onClick={_onExportFee6s1}>
        Chi tiết cước 6s+1
      </Button>
    </>
  )
}

export default Export
